<template>
    <div>
 <header id="site-header" class="header">
      <div class="container-fluid p-0">
        <div class="main-header-inner d-flex justify-content-between">
          <div class="logo-box">
            <a class="navbar-brand logo d-xl-inline-block " >
              <img class="img-fluid" src="http://devcdn.wistirna.com/assets/majestic/Majestic_logo.webp"
                alt="Logo Img" @click="$router.push('/')" style="cursor:pointer;">
            </a>
          </div>
          <div class="flex-grow-1">
            <div class="header-top">
              <div class="row align-items-center">
                <div class="col-lg-8 col-md-7 p-2">

                  <div class="topbar-link">
                    <ul class="list-inline">
                      <li>
                        <i class="fa-solid fa-location-dot"></i>
                        <a href="#">
                          Australia, Sri Lanka, India, UAE, Switzerland, Canada
                        </a>
                      </li>
                      <li><i class="fa-solid fa-envelope"></i>
                        <a href="mailto:sales@majesticcourier.com">
                          sales@majesticcourier.com
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-5 d-flex align-items-center justify-content-end">
                  <!-- <div class="search-icon me-3">
                    <button id="search"><i class="bi bi-search"></i></button>
                  </div> -->
                  <div class="social-icons d-none">
                    <ul class="list-inline">
                      <li>
                        <a href="#">
                          <i class="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                           <i class="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                         
  <i class="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i class="fab fa-linkedin"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div id="header-wrap">
              <div class="row">
                <div class="col">

                  <nav class="ht-navigation">
                    <a class="navbar-brand logo sticky-logo" >
                      <img class="img-fluid"
                        src="https://majesticcourier.com/wp-content/uploads/2023/01/Majestic_logo1.png" alt="Logo Img">
                    </a>
                    <div class="ht-mobile-menu-bg"></div>
                    <div class="navigation-top">
                      <div class="main-nav">
                        <ul id="menu-main-menu" class="menu d-none">
                          <li id="menu-item-2469"
                            class="menu-item menu-item-type-post_type menu-item-object-page 
              menu-item-home current-menu-ancestor current-menu-parent current_page_parent current_page_ancestor menu-item-has-children menu-item-2469">
                            <a >Home</a>
                          
                          </li>
                          <li id="menu-item-1428"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1428">
                            <a href="#">About</a>
                           
                          </li>
                          <li id="menu-item-1526"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1526">
                            <a href="#">Services</a>
                           
                          </li>
                          <li id="menu-item-1564"
                            class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-1564">
                            <a href="https://majesticcourier.com/contact-us/">Contact</a>
                          
                          </li>
                        </ul>
                      </div>
                    </div>
                    <button id="menu-toggle" class="nav-menu-toggle ht-toggler" type="button">
                      <i
                        class="bi bi-list"></i></button>
                    <div class="right-nav align-items-center d-flex">

  

                      <div class="header-number mx-4">
                        <i class="fa-solid fa-phone-volume"></i>
                        <div style="line-height: 15px;">
                          <div class="p-2">
                               <div style="font-size: 13px;
    font-weight: 500;">Australia</div>
    <div>
      <a href="tel:+61 452 201 075" 
                          style="font-size:12px;font-weight: 500;">+61 452 201 075</a>
    </div>
                          
                        
                          </div>
                       </div>
                       <div style="border: 1px solid lightgray;
    height: 25px;"></div>
                       <div style="line-height: 15px;">
                          <div class="p-2">
                               <span style="font-size: 13px;
    font-weight: 500;">Sri Lanka</span>
                          <a href="tel:+94 777 312 606" 
                          style="font-size: 12px;font-weight: 500;">+94 777 312 606</a>
                        
                          </div>
                       </div>
                       <div style="border: 1px solid lightgray;
    height: 25px;"></div>
                       <div style="line-height: 15px;">
                          <div class="p-2">
                               <span style="font-size: 13px;
    font-weight: 500;">India</span>
                          <a href="tel:+91 81242 43000"
                           style="font-size: 12px;font-weight: 500;">+91 81242 43000</a>
                        
                          </div>
                       </div>
                        <!-- <div>
                          <span>Australia</span>
                          <a href="tel: +61 39 408 5878"> +61 39 408 5878</a>
                        </div>
                        <div>
                          <span>Australia</span>
                          <a href="tel: +61 39 408 5878"> +61 39 408 5878</a>
                        </div> -->
                      </div>

                      <a class="themeht-btn primary-btn" @click="$router.push('/contactUs')" style="cursor:pointer;">
                        <span>contact us</span>
                        <i class="fa-solid fa-angles-right"></i>

                      </a>
                    </div>
                  </nav>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>


    </div>
</template>

<script>
export default{

    data (){
        return{

        }
    }
}
</script>

<style scoped>
@import "@/assets/theme-style6c2d.css";

</style>